// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2s59X","row":"Node_row__huPUk","label":"Node_label__1ExAU","footer":"Node_footer__2toOD"};